



















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import loader from "@/components/loader.vue";

import accountsApi from "@/services/accounts";
import { Action, Getter } from "vuex-class";

@Component({
  components: {
    loader
  }
})
export default class AccountCell extends Vue {
  @Prop() public value: any;
  @Prop({ default: '' }) view!: string;

  public loading = true;

  private account: any = null;
  public async created() {
    this.account = await accountsApi.GetAccountByID(this.value);
    this.loading = false;
  }
}
